import React from "react";
import "./header-social-feed-sidebar.sass";
export const HeaderSocialFeedSidebar = ({ copy, renderLink }) => /* @__PURE__ */ React.createElement("p", { className: "tint-header-social-feed-sidebar" }, copy, renderLink);
